import { Copy, Check } from 'lucide-react';
import React from 'react';
import "./CopyPlan.css"

function CopyPlanButton({ copyFeedback, onClickHandler, copyMode }) {

  return (
    <>
      {copyFeedback ? (
        <div className='copy-button-feedback-container'>
          <Check size={16}/>
          <p className='copy-button-feedback-text'>Copied</p>
        </div>
      ) : (
        <button className= {`copy-plan-button-container ${copyMode ? 'copy-state-active' : ""}`} onClick={onClickHandler}>
          <Copy size={16} />
        </button>
      )}
    </>
  );
}

export default CopyPlanButton;
